import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './hint.html';
import './hint.scss';

export interface HeatmapHintConfig {
    hint: SubscribableOrNullableValue<string>
}

@injectable()
export default class HeatmapHintVM {
    private isVisible = ko.observable(true);

    hint: Subscribable<string>

    constructor(
        @inject(wccModules.componentConfig) config: HeatmapHintConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.hint = ko.flattenComputed(config.hint, '');

        const isNeeded = ko.pureComputed(() => this.hint().length > 0 && this.isVisible());

        ko.applyBindingsToNode(info.element, {
            'visible': isNeeded,

            'css': {
                'wcc-heatmap__hint': true
            }
        });
    }

    hideHint = () => {
        this.isVisible(false);
    }
}